import actions from '../../../constants/actionTypes';
import { getDate } from '../../../utils/utils';
import { COMMON_CONST } from '../../../constants/constants';
import {
  EnumBookingNowShipStatusBrief,
  EnumPage,
  transEnum,
} from '../../../constants/enum';
import {
  handleChangeFilters,
  handleChangeTableActivePage,
  handleChangeTablePageSize,
  handleCloseDialogGeneric,
  handleOpenDialogGeneric,
} from '../../../redux/genericReducerHandler';

const initialState = {
  filters: {
    fromDate: getDate(-1),
    toDate: getDate(),
    orderCode: '',
    status: transEnum(EnumBookingNowShipStatusBrief.IN_PROGRESS),
  },
  table: {
    itemList: [],
    totalSize: 0,
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
  dialog: {
    isOpenDialog: false,
    itemId: 0,
  },
  dialogCanceledReason: {
    itemDetail: null,
  },
};

function orderManagementShipReducer(state = initialState, action) {
  const PAGE = EnumPage.NOW_SHIP_ORDER_MANAGEMENT.id;
  const { response, type } = action;
  switch (type) {
    case actions.OPEN_DIALOG_GENERIC: {
      return handleOpenDialogGeneric(PAGE, state, action);
    }
    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }
    case actions.CHANGE_FILTER_GENERIC: {
      return handleChangeFilters(PAGE, state, action, initialState);
    }
    case actions.CHANGE_ORDER_STATUS_NOW_SHIP: {
      const { bookingCode, status } = response;
      const { itemList } = state.table;
      return {
        ...state,
        table: {
          ...state.table,
          itemList: itemList.map(item =>
            (item.code === bookingCode
              ? {
                ...item,
                status,
              }
              : item),
          ),
        },
      };
    }
    case actions.RECEIVE_ORDER_MANAGEMENT_LIST_NOW_SHIP: {
      const { itemList, totalSize } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemList,
          totalSize,
        },
      };
    }
    case actions.OPEN_DIALOG_CANCELED_REASON: {
      const { itemDetail } = action.response;
      return {
        ...state,
        dialogCanceledReason: {
          itemDetail,
        },
      };
    }
    case actions.CLOSE_DIALOG_CANCELED_REASON: {
      return {
        ...state,
        dialogCanceledReason: {
          itemDetail: null,
        },
      };
    }
    default:
      return state;
  }
}

export default orderManagementShipReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/NowShip/OrderManagementNowShip/reducers.js